import { render } from "./AIS.vue?vue&type=template&id=53557e4b&scoped=true"
import script from "./AIS.vue?vue&type=script&lang=js"
export * from "./AIS.vue?vue&type=script&lang=js"

import "./AIS.vue?vue&type=style&index=0&id=53557e4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53557e4b"]])

export default __exports__